export default [
  {
    icon: 'description',
    value: 0,
    label: 'Note',
    color: 'blue-grey lighten-2'
  },
  { icon: 'help', value: 1, label: 'Question', color: 'blue' },
  { icon: 'warning', value: 2, label: 'Concern', color: 'orange' },
  { icon: 'emoji_objects', value: 3, label: 'Idea', color: 'green' },
  { icon: 'flag', value: 4, label: 'Claim', color: 'purple' },
  { icon: 'sort', value: 5, label: 'Section', color: 'grey darken-1' },
  { icon: 'assignment_turned_in', value: 6, label: 'Task', color: 'pink darken-1' }
];
